import { loader } from '@/js/utils/common';
import { init } from '@app/pages/auth';

loader(() => {
    init();
});
